import { Injectable, Inject } from '@angular/core';
import { ENVIRONMENT } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigManagerService {

  constructor(@Inject('APP_CONFIG') private config: any) {}

  get apiUrl(): string {
    //use ENVIRONMENT.apiUrl for any non-prod environment
    return this.production ? `${this.config.apiDomain}${ENVIRONMENT.apiUrl}` : ENVIRONMENT.apiUrl;
  }

  get tokenUrl(): string {
    //use ENVIRONMENT.tokenUrl for any non-prod environment
    return this.production ? `${this.config.tokenDomain}${ENVIRONMENT.tokenUrl}` : ENVIRONMENT.tokenUrl;
  }

  get production(): boolean {
    return ENVIRONMENT.production;
  }

  get clientId(): string {
    return ENVIRONMENT.clientId;
  }
}